import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import PaginationList from "../../common/Paginator/PaginationList";
import NewsDetail from "../../common/NewsDetail/NewsDetail";
import InterestSearchTag from "../../common/InterestSearchTag/InterestSearchTag";
import HotRank from "../../common/HotRank/HotRank";
import NewsItem from "../../common/NewsItem/NewsItem";

const FocusNews = (props) => {
    const { match } = props;
    const [newsDetailVisible, setNewsDetailVisible] = useState(false);

    useEffect(() => {
        setNewsDetailVisible(!!match.params.id)
    }, [match]);

    return (
        <div style={{width: 1200, display: 'flex', minHeight:1650}}>
            {
                newsDetailVisible
                ?   <NewsDetail url="/api/News"/>
                :   <PaginationList
                        title="新闻焦点"
                        url="/api/News"
                        renderItem={item => <NewsItem {...item} url="/news"/>}
                    />
            }
            <div style={{marginLeft: 16}}>
                <InterestSearchTag/>
                <div style={{height: 16}}/>
                <HotRank/>
            </div>
        </div>
    );
};

export default connect()(FocusNews);
